import { useQuery } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { fetchService } from "app/pages/digital-marketing/keywords-campaigns/reports/serp-feature-report/serp-feature-presence/SerpFeaturePresenceConst";

import useTrafficSearchApiParams from "../../../hooks/useApiParamsSearch";
import { ESourceType } from "../../../types";
import type { SearchCompetitorsScatterResponse, SearchCompetitorsQueryParams, SearchCompetitorsData } from "../types";
import type { FilterState } from "../utils/filtersReducer";
import { transformScatterData } from "../utils/transformer";

const API_CONFIG = {
    queryKey: "search-overview-top-keywords",
    endpoint: "/api/searchoverview/keywords/search-competitors-organic-total",
};

const buildFilterQuery = (filters: FilterState) => {
    if (filters.rising) {
        return `isrise;==;true`;
    }
    if (filters.new) {
        return `isnew;==;true`;
    }
    return null;
};

const fetchSearchCompetitorsScatter = async (params: SearchCompetitorsQueryParams) => {
    try {
        const response = await fetchService.get<SearchCompetitorsScatterResponse>(API_CONFIG.endpoint, { ...params });
        return transformScatterData(response);
    } catch (error) {
        Sentry.error("Error fetching search competitors scatter data", error);
    }
};

const useSearchCompetitorsData = ({ filters }: { filters?: FilterState }): SearchCompetitorsData => {
    const { trafficSearchApiParams } = useTrafficSearchApiParams();
    const filterString = buildFilterQuery(filters);

    const params: SearchCompetitorsQueryParams = {
        ...trafficSearchApiParams,
        sourceType: ESourceType.ORGANIC,
        limit: 10,
        filter: filterString ?? undefined,
        webSource: "Total",
    };

    const { data, isLoading } = useQuery({
        queryKey: [API_CONFIG.queryKey, params],
        queryFn: () => fetchSearchCompetitorsScatter(params),
    });

    return {
        scatterDataItems: data?.scatterDataItems ?? [],
        mainSiteData: data?.mainSiteData,
        minMaxValues: data?.minMaxValues ?? {},
        isLoading,
    };
};

export default useSearchCompetitorsData;
